export const expiredStudentIdPush = {
  en: 'Your Student ID will expire within one month. Please update it as soon as you can!',
  hu: 'A diákigazolványod érvényessége le fog járni 1 hónapon belül, kérlek frissítsd amint tudod!',
};
